import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { getCurrentEnterpriseReservationGroupId } from '@mews-commander/legacy-entities';
import { changeTab, PricingTab } from '@mews-commander/modules/src/modules/reservationModule';
import { ReservationTab } from '@mews-commander/modules/src/types/reservationTab';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Reservation/Detail/$reservationId/Pricing')({
    component: Component,
    staticData: {
        title: TextKey.ReservationDetails,
        routeName: RouteName.ReservationDetailPricing,
        owner: MewsTeam.Reservations,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.WhatReservationModuleWhatFeatures),
    },
});

function Component() {
    const { reservationId } = Route.useParams();
    const dispatch = useCommanderThunkDispatch();

    const groupId = useCommanderSelector((state) =>
        getCurrentEnterpriseReservationGroupId(state, {
            id: reservationId,
        })
    );

    useEffect(() => {
        dispatch(
            changeTab({
                reservationTab: ReservationTab.Pricing,
                reservationId,
                scope: groupId as string,
            })
        );
    }, [dispatch, groupId, reservationId]);

    return <PricingTab scope={groupId as string} />;
}
